import {
  type EventSourceMessage,
  fetchEventSource,
} from '@microsoft/fetch-event-source';

import { magellanClient } from '../../../infra/axios';
import type {
  CreateThreadMessageRequestDTO,
  CreateThreadMessageResponseDTO,
  CreateThreadRequestDTO,
  CreateThreadResponseDTO,
  GetThreadByIdResponseDTO,
  GetThreadsResponseDTO,
} from './dto';

export async function getThreadById(
  threadId: number,
): Promise<GetThreadByIdResponseDTO> {
  const response = await magellanClient.get<GetThreadByIdResponseDTO>(
    `assistant/threads/${threadId}`,
  );

  return response.data;
}

export async function getThreads(): Promise<GetThreadsResponseDTO> {
  const response =
    await magellanClient.get<GetThreadsResponseDTO>('assistant/threads');

  return response.data;
}

export async function createThread(
  payload: CreateThreadRequestDTO,
): Promise<CreateThreadResponseDTO> {
  const response = await magellanClient.post<CreateThreadResponseDTO>(
    'assistant/threads',
    payload,
  );

  return response.data;
}

export async function createThreadMessage({
  threadId,
  payload,
}: {
  threadId: number;
  payload: CreateThreadMessageRequestDTO;
}): Promise<CreateThreadMessageResponseDTO> {
  const response = await magellanClient.post<CreateThreadMessageResponseDTO>(
    `assistant/threads/${threadId}/messages`,
    payload,
  );

  return response.data;
}

export async function generateAnswerStream({
  threadId,
  onmessage,
  onclose,
  onerror,
  signal,
}: {
  threadId: number;
  onmessage: (event: EventSourceMessage) => void;
  onclose: () => void;
  onerror: (error: Error) => void;
  signal: AbortSignal;
}) {
  const url =
    import.meta.env.VITE_MAGELLAN_BASE_URL +
    `/assistant/threads/${threadId}/generateAnswer`;

  return fetchEventSource(url, {
    method: 'GET',
    signal,
    onmessage,
    onclose,
    onerror,
  });
}
